import { UserDeleteDialog } from './UserDeleteDialog';

export * from './UserDeleteDialog.types';
export { UserDeleteDialog };

export default UserDeleteDialog;
